import { FastenerBasePointEnum } from '../models/cutting/cutting-custom-hole.model';
import { Position } from '../models/cutting/cutting-svg.model';

export class FastenerBasePointHelper {
  static getBasePointAnglePosition(side: Position, basePoint: FastenerBasePointEnum): Position {
    switch (side) {
      case 'tc':
        return basePoint === FastenerBasePointEnum.Start ? 'tl' : 'tr';

      case 'rc':
        return basePoint === FastenerBasePointEnum.Start ? 'tr' : 'br';

      case 'bc':
        return basePoint === FastenerBasePointEnum.Start ? 'br' : 'bl';

      case 'lc':
        return basePoint === FastenerBasePointEnum.Start ? 'bl' : 'tl';
    }
  }

  static setBasePoint(
    point: Position,
    isolatedSide: Position,
    multiSideForce = false
  ): { selectedPoint: FastenerBasePointEnum; selectedSide: Position } {
    let selectedPoint: FastenerBasePointEnum;
    let selectedSide: Position;

    const selectAnyBasePoint = isolatedSide === undefined || multiSideForce;

    // if start side
    if (
      (isolatedSide === 'tc' && point === 'tl') ||
      (isolatedSide === 'bc' && point === 'br') ||
      (isolatedSide === 'lc' && point === 'bl') ||
      (isolatedSide === 'rc' && point === 'tr')
    ) {
      // selectedSide = isolatedSide;
      selectedPoint = FastenerBasePointEnum.Start;
    } else {
      // selectedSide = isolatedSide;
      selectedPoint = FastenerBasePointEnum.End;
    }

    if (selectAnyBasePoint) {
      // !!! multiside use only lc and rc !!!
      switch (point) {
        case 'tl':
          selectedSide = 'lc';
          selectedPoint = FastenerBasePointEnum.End;
          break;

        case 'tr':
          selectedSide = 'rc';
          selectedPoint = FastenerBasePointEnum.Start;
          break;

        case 'br':
          selectedSide = 'rc';
          selectedPoint = FastenerBasePointEnum.End;
          break;

        case 'bl':
          selectedSide = 'lc';
          selectedPoint = FastenerBasePointEnum.Start;
          break;
      }
    }

    return { selectedPoint: selectedPoint, selectedSide: selectedSide };
  }
}
